import {createUseStyles} from "react-jss";
import {colors} from "constants/colors";
import { breakpoints } from '../../../constants/breakpoints';

const styles = createUseStyles({
  gridMobileWrapperClassName: {
    marginBottom: 0,
    padding: 0
  },
  gridWrapperClassName: {
    "& .rdt_TableCol_Sortable": {
      overflow: "visible"
    },
    borderRadius: 'unset',
    border:"none",
    "& .rdt_TableCell:last-child": {
      paddingRight: "24px"
    },
  },
  retroHistory: {
    paddingLeft: "144px",
    paddingRight: "144px",
    paddingTop: "32px",
    paddingBottom: "0",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      padding: "18px"
    },
  },
  retroHistoryHeader: {
    display: 'flex',
    flexDirection: 'row',
    [`@media (max-width: ${breakpoints.md}px)`]: {
      flexDirection: 'column',
    },
  },
  retroHistoryHeaderTitleContainer: {
    width: '100%'
  },
  retroHistoryHeaderButtonContainer: {
    margin: 'auto',
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: 'fit-content',
      margin: '12px 0 0 0',
    },
  },
  downloadLoadingState: {
    backgroundColor: `${colors.brightBlue} !important`,
    pointerEvents: "none",
    border: `1px solid ${colors.brightBlue}`
  },
  spinnerStyle: {
    '& span': {
      borderColor: `${colors.darkerGrey} ${colors.darkerGrey} transparent !important`
    }
  },
  retroHistoryDownloadSVG: {
    '& path': {
      stroke: colors.grey
    }
  },
  retroHistoryDownloadSVGDisabled: {
    '& path': {
      stroke: colors.darkGrey
    }
  },
  retroHistoryCard: {
    marginBottom: "48px",
    borderColor: colors.lightGrey,
    width: "100%",
    boxSizing: "border-box",
    '& .card-title': {
      fontSize: 18,
      fontWeight: 600,
      lineHeight: '28px',
      color: colors.lightBlack
    },
    '& .card-text': {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px',
      color: colors.mediumGrey
    },
    '& .card-header': {
      borderColor: colors.lightGrey,
      backgroundColor: 'transparent'
    },

    '& .card-header, & .card-footer': {
      borderColor: colors.lightGrey,
      padding: '20px 24px',
    },
  },
  retroHistoryCardHeaderSmall: {
    '&.card-header': {
      padding: '12px 16px',
    },
  },
  retroHistoryCardBody: {
    padding: "unset",
    '& .rdt_TableHeadRow': {
      color: colors.mediumGrey,
      fontSize: 12,
      fontWeight: 500,
    },
    '& .rdt_TableRow *': {
      color: colors.inactiveGrey,
      fontSize: 14,
      fontWeight: 400,
      '& .bold': {
        fontWeight: 500,
        fontSize: 14,
        color: colors.grey,
        lineHeight: "20px"
      },
      '& .travelerName': {
        fontSize: 14,
        fontWeight: 400,
        color: colors.mediumGrey,
      }
    }
  },
  text: {
    fontSize: 16,
    lineHeight: "24px",
    color: colors.mediumGrey,
  },
  bold: {
    fontWeight: 500,
    fontSize: 14,
    color: colors.grey,
    lineHeight: "20px"
  },
  loyaltyPointsText: {
    margin: 0,
    fontSize: 16,
  }
});

export default styles;
